import React from 'react'

import { constants } from 'helpers'

const { MEMBERSHIP_VALUES } = constants

const yesNoOptions = [
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
]

const filters = [
  {
    title: 'Card Submitted',
    name: 'cardSubmitted',
    options: yesNoOptions,
  },
  {
    title: 'Appl. Completed',
    name: 'appSubmitted',
    options: yesNoOptions,
  },
  {
    title: 'Membership Type',
    name: 'membershipType',
    options: Object.entries(MEMBERSHIP_VALUES).map(([key, value]) => ({
      label: value,
      value: key,
    })),
  },
]

const ApplicationFilters = ({ activeFilters, onFilter }) => {
  const handleChange = e => {
    e.preventDefault()
    const { name, value } = e.target
    onFilter({ [name]: value })
  }

  return (
    <div className="flex items-center space-x-5">
      {filters.map(filter => (
        <div key={filter.name} className="flex flex-col items-center">
          <div className="text-white text-sm font-semibold mb-2">{filter.title}</div>
          <select
            className="w-full text-sm rounded-md h-7 px-2"
            name={filter.name}
            value={activeFilters[filter.name] || ''}
            onChange={handleChange}
          >
            <option value="">-</option>
            {filter.options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      ))}
    </div>
  )
}

export default ApplicationFilters
